export default {
  moneySymbol: 'RON',
  deleteThisLine: 'Șterge acest rând',
  copyThisLine: 'Copiază acest rând',
  form: {
    lightFilter: {
      more: 'Mai multe filtre',
      clear: 'Curăță',
      confirm: 'Confirmă',
      itemUnit: 'elemente'
    }
  },
  tableForm: {
    search: 'Caută',
    reset: 'Resetează',
    submit: 'Trimite',
    collapsed: 'Extinde',
    expand: 'Restrânge',
    inputPlaceholder: 'Introduceți',
    selectPlaceholder: 'Selectați'
  },
  alert: {
    clear: 'Anulează selecția',
    selected: 'Selectat',
    item: 'elemente'
  },
  pagination: {
    total: {
      range: 'De la',
      total: 'elemente/total',
      item: 'elemente'
    }
  },
  tableToolBar: {
    leftPin: 'Fixează la început',
    rightPin: 'Fixează la sfârșit',
    noPin: 'Nu fixa',
    leftFixedTitle: 'Fixează în stânga',
    rightFixedTitle: 'Fixează în dreapta',
    noFixedTitle: 'Nu fixa',
    reset: 'Resetează',
    columnDisplay: 'Afișare coloane',
    columnSetting: 'Setări coloane',
    fullScreen: 'Ecran complet',
    exitFullScreen: 'Ieși din ecran complet',
    reload: 'Reîncarcă',
    density: 'Densitate',
    densityDefault: 'Normal',
    densityLarger: 'Larg',
    densityMiddle: 'Mediu',
    densitySmall: 'Compact'
  },
  stepsForm: {
    next: 'Pasul următor',
    prev: 'Pasul anterior',
    submit: 'Trimite'
  },
  loginForm: {
    submitText: 'Autentificare'
  },
  editableTable: {
    onlyOneLineEditor: 'Se poate edita doar un rând simultan',
    action: {
      save: 'Salvează',
      cancel: 'Anulează',
      delete: 'Șterge',
      add: 'Adaugă un rând'
    }
  },
  switch: {
    open: 'Deschide',
    close: 'Închide'
  }
};